export default __webpack_public_path__ + "static/media/7eleven.5bac6924.png";